// extracted by mini-css-extract-plugin
module.exports = {"channelLink":"Channel_channelLink__3OC9F","actions":"Channel_actions__vpMA3"};